import React from 'react'
import "./Footer.css";

const Footer = () => {
  return (
    <div>
        <p className='foot'> &copy; Toufik_Bagwan </p>
    </div>
  )
}

export default Footer;